import CompanyPropertiesUnassignedContent from "../../features/companyProperties/widgets/CompanyPropertiesUnassignedContent";

function CompanyPropertiesUnassignedScreen() {
  return <CompanyPropertiesUnassignedContent />;
}

export default CompanyPropertiesUnassignedScreen;
